<template>
  <DropdownComponent placement="bottom-start">
    <ButtonComponent>
      <template #label>
        <div class="row middle">
          <span>{{ label }}</span>
          <FontAwesomeIcon :icon="['fal', 'angle-right']" style="margin: 0 0.5rem" />
          <b>{{ active.label }}</b>
        </div>
      </template>
    </ButtonComponent>

    <template #dropdown>
      <ButtonComponent
        v-for="item in items"
        :key="item.value"
        :icon="value === item.value ? ['fal', 'check'] : null"
        :label="item.label"
        @click="$emit('input', item)"
      />
    </template>
  </DropdownComponent>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import { DropdownComponent } from 'vue-elder-dropdown'

export default {
  props: {
    value: [String, Number],
    label: String,
    items: Array,
  },
  computed: {
    active() {
      return this.items.find(i => i.value === this.value)
    },
  },
  components: {
    ButtonComponent,
    DropdownComponent,
  },
}
</script>
